import { RequestMethod } from '@angular/http';
import {
  NETWORK_SERVICE_ERROR_CODE,
  UNREACHABLE_SERVICE_ERROR_CODE,
  VALIDATION_ERROR_CODE,
  NOT_AUTHORIZED_CODE,
  INTERNAL_SERVICE_ERROR_CODE,
  BAD_REQUEST_ERROR_CODE,
  NOT_FOUND_ERROR_CODE,
  FORBIDDEN_ERROR_CODE,
  CONFLICT_ERROR_CODE,
  BadRequestError,
  NetworkServiceError,
  ReservationAvailabilityError,
  ReservationForbiddenError,
  ReservationValidationError,
  ReservationAuthorizationError,
  OverrideReservationGuestError,
  ServiceError,
  UnknownServiceError,
  UnreachableServiceError,
  ValidationError,
  NotAuthorized,
  NotFoundError,
  ForbiddenError
} from '../../model/errors';
import {useDefault, useFirst} from '../../../common/common';
import {ReservationErrorMapping} from '../../model/errors/reservation-error-mapping.model';
import {ReservationErrorCodes} from '../../model/errors/reservation-error-codes.model';
import {ServiceErrorMapper} from "./service-error.mapper";

export class ReservationV2ErrorMapper extends ServiceErrorMapper {
    map(error: any): ServiceError {
        const serviceError: ServiceError = super.map(error);
        const errorDetails = useDefault(error.error, {});
        // 400
        if (serviceError.code === BAD_REQUEST_ERROR_CODE) {
            const defaultValidationError = new ReservationValidationError(errorDetails.code, ReservationErrorMapping.getMapping(errorDetails.code), serviceError.details);
            return this._mapCodeOrDefault(errorDetails.code, defaultValidationError);
        }
        // 403
        if (serviceError.code === FORBIDDEN_ERROR_CODE) {
            const defaultValidationError = new ReservationForbiddenError(errorDetails.code, ReservationErrorMapping.getMapping(errorDetails.code), serviceError.details);
            return this._mapCodeOrDefault(errorDetails.code, defaultValidationError);
        }
        return serviceError;
    }

    private _mapCodeOrDefault(errorCode: string, defaultError: ServiceError): ServiceError  {
        const messageKey = ReservationErrorMapping.getMapping(errorCode);

        switch (errorCode) {
            /* CHECK THE AVAILABILITY OF GUESTS IN THE ROOM(S) (in red under adults and children) */
            case ReservationErrorCodes.ERROR_MAX_OCCUPANCY_EXCEEDED:
            case ReservationErrorCodes.ERROR_MAX_OCCUPANCY_EXCEEDED_AVAIL:
                // v2 403 - CRS_15999 - The occupancy requested is higher than available for the product.
                // v1 500 - 052163 The number in party exceeds the maximum room occupancy.
            {
                return new ReservationForbiddenError('errorGuests' + errorCode, messageKey, true);
            }
            /* CHECK THE AVAILABILITY OF THE RESERVATION ON THE SELECTED DATES  (in red under checkout )*/
                // ERROR_052113, ERROR_052150,  ERROR_052109
                //v2 403 CRS_15500 - The requested product is not available.
                //v1 500 052109 - Rooms are not available with the selected preferences on the requested dates. Please adjust your dates/selections, if possible.
                //v1 500 052150 - The hotel is sold out. Â Please call the hotel directly or try another hotel.
                //v1 500 052113  - errorDates: The requested rate is not available. Request a different rate
            case ReservationErrorCodes.ERROR_PRODUCT_NOT_AVAILABLE:
            case ReservationErrorCodes.ERROR_NO_ROOM_AVAILABILITY:
            case ReservationErrorCodes.ERROR_INVALID_DATES:
            case ReservationErrorCodes.ERROR_INVALID_DATE_RANGE:
            {
                return new  ReservationAvailabilityError('errorDates' + errorCode, messageKey, false, true);
            }
            /*(in black under Change Stay Details header)*/
            case ReservationErrorCodes.ERROR_INVALID_PAYMENT_TRANSACTION_ID:
            case ReservationErrorCodes.ERROR_ALREADY_CANCELLED:
                // v2 400, CRS_12103 - Invalid length for /data/hotelReservation/segments[1]/formOfPayment/paymentByPoints[1]/transactionId [#value#] max expected: 9, got: xx
                // v1 500 052138 - The reservation system was unable to process your request. Please check all data to make sure it is correct
            {
                return new ReservationAvailabilityError('errorRooms' + errorCode, messageKey, false, false, true);
            }

            /* We need to explicitly handle this because they are returned by multiple HTTP response codes(in black under Change Stay Details header)*/
            case ReservationErrorCodes.ERROR_LOYALTYID_UPDATE_NOT_ALLOWED:
            case ReservationErrorCodes.ERROR_NOT_AUTHORIZED:
            case ReservationErrorCodes.ERROR_RESERVATION_ACCESS:
            case ReservationErrorCodes.ERROR_REQUIRED_CHECKED_IN:
                // v2 400, CRS_733 - A frequent guest number change requires a cancel and a rebook
                // v1 500 - 050535 - A frequent guest number change requires a cancel and a rebook
            {
                return new ReservationAuthorizationError(errorCode, messageKey);
            }

            /* We need to explicitly handle this because it is returned by multiple HTTP response codes*/
            case ReservationErrorCodes.ERROR_RESERVTION_NOT_ACCESSIBLE_VIA_WEB:
            case ReservationErrorCodes.ERROR_SECURITY:
            case ReservationErrorCodes.ERROR_ALREADY_CHECKED_IN:
            case ReservationErrorCodes.ERROR_DEPOSIT_REQUIRED:
                // v2 400, CRS_12080 - Reservation not accessible by web and mobile
                // v1 500 - 052149 - The reservation cannot be viewed via the Internet
            {
                return new ReservationValidationError(errorCode, messageKey);
            }
        }
        return defaultError;
      }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/services/mapper/reservation-v2-error.mapper.ts